var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudyPlaner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.3332925h20v1.3333367H0Z",
    fill: "#000",
    style: {
      strokeWidth: 1.25935
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.333348 2.6666292V13.333361h13.333405V2.6666292ZM2.0000113 1.3332925H18.000026V13.999935c0 .176812-.07027.346447-.195199.471499-.125053.124929-.294688.1952-.4715.1952H2.666686c-.1768127 0-.3463842-.07027-.4714125-.1952-.1250156-.125053-.1952622-.294687-.1952622-.471499Z",
    fill: "#000",
    style: {
      strokeWidth: 1.25935
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0453958 18.666707H4.5067221l3.0133472-5.220005 1.1546597.6667zm9.4560802 0h-1.538673l-2.629397-4.553305 1.154698-.6667z",
    fill: "#000",
    style: {
      strokeWidth: 1.25935
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyPlaner);
export default __webpack_public_path__ + "static/media/study_planer.a2518185d70652233aa3f399960ce35a.svg";
export { ForwardRef as ReactComponent };